import axios from 'axios';

// Base URL and API token for NocoDB
const BASE_URL = "https://app.nocodb.com/api/v2/tables/mxp2zh52yeohtwb/records";
const API_TOKEN = "BJbCKPah3Ph7D1BIgg_Uayk_HVCwef3JDiRUiBab";

// Axios instance with default config
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'xc-token': API_TOKEN,
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message);
    throw error;
  }
);

// Add a new patient
export const addPatient = async (patientData) => {
  try {
    // Transform the nested form data to match your table schema exactly
    const transformedData = {
      // Name fields
      firstName: patientData.name?.firstName || '',
      middleName: patientData.name?.middleName || '',
      lastName: patientData.name?.lastName || '',
      
      // Contact fields - note: your schema uses mobileNumber (number type)
      mobileNumber: patientData.contact?.mobile ? parseInt(patientData.contact.mobile) : 0,
      email: patientData.contact?.email || '',
      alternatePhone: patientData.contact?.alternatePhone ? parseInt(patientData.contact.alternatePhone) : 0,
      
      // Basic fields
      gender: patientData.gender || '',
      birthDate: patientData.birthDate ? patientData.birthDate.format('YYYY-MM-DD') : '',
      maritalStatus: patientData.maritalStatus || '',
      
      // Address fields - matching your schema field names
      addUse: patientData.address?.use || '',
      addType: patientData.address?.type || '',
      addLineone: patientData.address?.line1 || '',
      addLinetwo: patientData.address?.line2 || '',
      addCity: patientData.address?.city || '',
      addState: patientData.address?.state || '',
      addPostalcode: patientData.address?.postalCode || '',
      
      // Organization fields - matching your schema field names
      generalPractitioner: patientData.generalPractitioner?.organization || '',
      managingOrg: patientData.managingOrganization || '',
    };

    const response = await api.post('/', transformedData);
    return response.data;
  } catch (error) {
    console.error('Error adding patient:', error);
    throw error;
  }
};

// Get all patients
export const getAllPatients = async (limit = 1000, offset = 0) => {
  try {
    const response = await api.get('/', {
      params: {
        limit,
        offset,
        shuffle: 0,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching patients:', error);
    throw error;
  }
};

// Get a single patient by ID
export const getPatientById = async (id) => {
  try {
    const response = await api.get(`/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching patient with id ${id}:`, error);
    throw error;
  }
};

// Update an existing patient
export const updatePatient = async (id, patientData) => {
  try {
    const transformedData = {
      recId: id,
      // Name fields
      firstName: patientData.name?.firstName || '',
      middleName: patientData.name?.middleName || '',
      lastName: patientData.name?.lastName || '',
      
      // Contact fields
      mobileNumber: patientData.contact?.mobile ? parseInt(patientData.contact.mobile) : 0,
      email: patientData.contact?.email || '',
      alternatePhone: patientData.contact?.alternatePhone ? parseInt(patientData.contact.alternatePhone) : 0,
      
      // Basic fields
      gender: patientData.gender || '',
      birthDate: patientData.birthDate ? patientData.birthDate.format('YYYY-MM-DD') : '',
      maritalStatus: patientData.maritalStatus || '',
      
      // Address fields
      addUse: patientData.address?.use || '',
      addType: patientData.address?.type || '',
      addLineone: patientData.address?.line1 || '',
      addLinetwo: patientData.address?.line2 || '',
      addCity: patientData.address?.city || '',
      addState: patientData.address?.state || '',
      addPostalcode: patientData.address?.postalCode || '',
      
      // Organization fields
      generalPractitioner: patientData.generalPractitioner?.organization || '',
      managingOrg: patientData.managingOrganization || '',
    };

    const response = await api.patch('/', transformedData);
    return response.data;
  } catch (error) {
    console.error(`Error updating patient with id ${id}:`, error);
    throw error;
  }
};

// Delete a patient
export const deletePatient = async (id) => {
  try {
    await api.delete('/', {
      data: { recId: id }
    });
    return { success: true };
  } catch (error) {
    console.error(`Error deleting patient with id ${id}:`, error);
    throw error;
  }
};

// Export all functions as PatientAPI object
export const PatientAPI = {
  create: addPatient,
  getAll: getAllPatients,
  getById: getPatientById,
  update: updatePatient,
  delete: deletePatient,
};

export default PatientAPI;